module.exports = __webpack_public_path__ + "img/tn-timeline-misc-17.f7355474.jpg";